export const externalReviewSteps = {
  initialExternalReviewScreen: 0,
  exportCompletedUncategorisedDataSheet: 1,
  importCompletedUncategorisedDataSheet: 2,
  externalReviewLoading: 3,
};